import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data/content";

export const BrandMarquee = ({ dark = false }) => (
  <div
    data-testid="brand-marquee"
    className={`marquee-mask border-y py-5 ${
      dark ? "border-white/10 bg-ink text-white" : "border-black/10 bg-paper text-ink"
    }`}
  >
    <Marquee speed={40} gradient={false}>
      {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((item, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8">
          <span className="font-display text-xl font-extrabold uppercase tracking-tight sm:text-2xl">
            {item}
          </span>
          <span className="text-brand">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
